import React from 'react';
import Icon from '../../../components/AppIcon';

const StatsOverview = ({ progress }) => {
  const stats = [
    {
      id: 1,
      label: "Cursos em Andamento",
      value: progress?.isEnrolled ? "1" : "0",
      icon: "BookOpen",
      color: "text-secondary",
      bgColor: "bg-secondary/10"
    },
    {
      id: 2,
      label: "Progresso do Curso",
      value: `${progress?.progressPercentage ?? 0}%`,
      icon: "Clock",
      color: "text-success",
      bgColor: "bg-success/10"
    },
    {
      id: 3,
      label: "Aulas Concluídas",
      value: String(progress?.completedLessons ?? 0),
      icon: "CheckCircle",
      color: "text-accent",
      bgColor: "bg-accent/10"
    },
    {
      id: 4,
      label: "Total de Aulas",
      value: String(progress?.totalLessons ?? 0),
      icon: "Award",
      color: "text-primary",
      bgColor: "bg-primary/10"
    }
  ];

  return (
    <section className="mb-12">
      <h2 className="text-2xl font-heading font-semibold text-foreground mb-6">
        Seu Progresso
      </h2>
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4">
        {stats?.map((stat) => (
          <div
            key={stat?.id}
            className="bg-card rounded-lg p-6 shadow-tier-1 hover:shadow-tier-2 transition-all duration-300"
          >
            <div className="flex items-center justify-between mb-4">
              <div className={`w-10 h-10 ${stat?.bgColor} rounded-lg flex items-center justify-center`}>
                <Icon 
                  name={stat?.icon} 
                  size={50} 
                  className={stat?.color}
                />
              </div>
            </div>
            
            <div className="space-y-1">
              <p className="text-2xl font-heading font-bold text-card-foreground">
                {stat?.value}
              </p>
              <p className="text-sm text-muted-foreground font-caption">
                {stat?.label}
              </p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default StatsOverview;
